export default "__VITE_ASSET__76b4bc00__"